import { useState } from 'react';

import eaLogo from '@cartwhl/ui/assets/client-logos/ea.svg';

export default function ClientBrand({
  clientSlug,
  companyName,
}: {
  clientSlug?: string;
  companyName?: string;
}) {
  const [failedLogo, setFailedLogo] = useState<string>();
  const slug = clientSlug?.trim().toLowerCase();
  if (!slug || slug === 'default') return null;

  const name = slug === 'ea' ? 'Electronic Arts' : companyName?.trim() || slug;
  const logo = slug === 'ea' ? eaLogo : undefined;

  return (
    <div className="border-primary min-w-0 border-l pl-3 sm:pl-5" title={name}>
      {logo && logo !== failedLogo ? (
        // EA's lockup begins with a square mark; show that mark on phones.
        <span className="block h-6 w-6 overflow-hidden sm:w-[134px]">
          <img
            src={logo}
            alt={name}
            width={2225}
            height={399}
            className="h-6 w-[134px] max-w-none brightness-0 dark:brightness-100"
            onError={() => setFailedLogo(logo)}
          />
        </span>
      ) : (
        <span className="text-primary block max-w-20 truncate text-sm font-medium sm:max-w-56 sm:text-base">
          {name}
        </span>
      )}
    </div>
  );
}
